import request from '../../../core/wrappers/axios-wrapper';
import { ApiURL } from '../../../types/constants/apiUrls/api-urls';
import { RequestType } from '../../../types/enums/request-enums';

const AddIpWhiteList = (data: any): Promise<any> =>
    request({
        url: ApiURL.Command.AddIpWhiteList,
        method: RequestType.POST,
        data,
    });

const UpdateIpWhiteList = (id: number, data: any): Promise<any> =>
    request({
        url: `${ApiURL.Command.UpdateIpWhiteList}/${id}`,
        method: RequestType.PUT,
        data,
    });

const DeleteIpWhiteList = (id: number, data: any): Promise<any> =>
    request({
        url: `${ApiURL.Command.DeleteIpWhiteList}/${id}`,
        method: RequestType.DELETE,
        data,
    });

const IpWhiteListCommand = {
    AddIpWhiteList,
    UpdateIpWhiteList,
    DeleteIpWhiteList,
};

export default IpWhiteListCommand;

